export default "__VITE_ASSET__CNEOpRiX__"